import { useAuth } from "../AuthContext";
import { useUserPermissions } from "./useUserPermissions";

function useHasPermission({ permissionCode }: { permissionCode: string }) {
  const { user } = useAuth();
  const { data } = useUserPermissions(user?.ID);

  return data?.some((p) => p.Code === permissionCode);
}

export default useHasPermission;
